import * as React from 'react'

import {
  Box,
} from '@mui/material'

function Dashboard() {

  return (
    <Box className='w-full'>
      Dashboard
    </Box>
  );
}

export default Dashboard;